export default __webpack_public_path__ + "static/image-06e1f4fef32cc3fa38e1c83a20d6f9cc.png";